import { useParams } from 'react-router-dom'
import ProfileForm from './ProfileForm'
import { useGetUsersQuery } from './usersApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import { toast } from 'react-toastify'
import useAuth from '../../hooks/useAuth'
import { useNavigate } from "react-router-dom"



const Profile = () => {
    useTitle('DPE: My Profile')
    const navigate = useNavigate()

    // only current user can see their own profile
    const { id } = useParams()
    const {userId} = useAuth()

    if (id !== userId) {
        toast.error('You are not authorized')
        navigate('/login')
    }

    // get user data
    const { user } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            user: data?.entities[id]
        }),
    })
    if (!user) return <PulseLoader color={"#5f788a"} />

    const content = <ProfileForm user={user} />

    return content

}
export default Profile